import { Helmet } from "react-helmet-async";
import { LEAGUE } from "@/lib/site";

export default function Seo({ title, description, image = "/images/hero.jpg", jsonLd, noindex }) {
  const full = title ? `${title} | ${LEAGUE}` : `${LEAGUE} | Official Website`;
  const desc = description || "Official website of the Telangana–Andhra T10 League, a proposed 12-franchise T10 tennis-ball cricket league across Hyderabad and Amaravati, organised by CGN Sports.";
  const url = typeof window !== "undefined" ? window.location.href : "";
  const img = image?.startsWith("http") ? image : `${typeof window !== "undefined" ? window.location.origin : ""}${image}`;
  return (
    <Helmet>
      <title>{full}</title>
      <meta name="description" content={desc} />
      {noindex && <meta name="robots" content="noindex,nofollow" />}
      <link rel="canonical" href={url} />
      <meta property="og:type" content="website" />
      <meta property="og:title" content={full} />
      <meta property="og:description" content={desc} />
      <meta property="og:image" content={img} />
      <meta property="og:url" content={url} />
      <meta name="twitter:card" content="summary_large_image" />
      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
}
